import { init, setUser as sentrySetUser } from '@sentry/react';
import { BrowserTracing } from '@sentry/react';
import { getCurrentRoute } from './utils';

export function initialiseSentry(config: Parameters<typeof init>[0]) {
  init({
    integrations: [
      new BrowserTracing({
        beforeNavigate: (context) => {
          const route = getCurrentRoute();
          return {
            ...context,
            name: route,
          };
        },
      }),
    ],
    ...config,
  });
}

export function setUser(user: Parameters<typeof sentrySetUser>[0]) {
  sentrySetUser(user);
}
